
//import ConstUtils from '@/utils/ConstUtils.js';
import MapUtils from '@/utils/MapUtils.js';

export default class CardEvents {
  
  constructor(eventsDomain) {
    this.eventsDomain = eventsDomain;
    this.domain = this.eventsDomain.domain;
  }
  
  contains(name) {
    if (name) {
      //
    }
    return false;
  }
  
  save(details, address) {
    var event = new CardEvents.Save.Request(details, address);
    var wrappedEvent = this.eventsDomain.initRequest(event);
    return wrappedEvent;
  }
  
  static Save = {
    Names: {
      Request:  'CardSaveRequestEvent',
      Response: 'CardSavedResponseEvent',
    },

    Errors: {
      IncorrectOldPassword: {
        id: 'IncorrectOldPassword',
        msg: 'The old password is incorrect',
        details: '',
      },
    },

    Request: function(cardDetails, cardAddress) {
      var event = {
          ccAddress: cardAddress,
          handler: CardEvents.Save.Names.Request,
          eventName: CardEvents.Save.Names.Request,
      }
      MapUtils.updateMap(cardDetails, event);
      return event
    },
  }


  list(params) {
    var event = new CardEvents.List.Operation(params);
    var wrappedEvent = this.eventsDomain.initRequest(event);
    return wrappedEvent;
  }

  static List = {
    Names: {
      Operation: 'CardListQueryOperation',
      Notification: 'CardListQueryNotification',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: ''
      },
    },

    Operation: function(params) {
      var event = {
        handler: CardEvents.List.Names.Operation,
        eventName: CardEvents.List.Names.Operation,
      }
      
      event["Params"] = params.data ? params.data : params;

      return event;
    },
  }

  declined(rcInvoice) {
    var event = new CardEvents.Declined.Operation(rcInvoice);
    var wrappedEvent = this.eventsDomain.initRequest(event);
    return wrappedEvent;
  }

  static Declined = {
    Names: {
      Operation: 'SendCardDeclinedEmailCommandOperation',
      Notification: 'SendCardDeclinedEmailCommandNotification',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: ''
      },
    },

    Operation: function(params) {
      var event = {
        handler: CardEvents.Declined.Names.Operation,
        eventName: CardEvents.Declined.Names.Operation,
      }
      
      event["Params"] = {
        Invoice: params.data
      }

      return event;
    },
  }

   
}